// extracted by mini-css-extract-plugin
export default {"editor":"editor---CC15Y"};